<template>
  <Modal
    :id="'cmp-catalog-projects-new_project'"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $t("project")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'project_name'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="project_name"
            isModel
            :placeholder="$t('project_name')"
            @valuechanged="onTextFieldValueChange"
          />

          <Dropdown
            :options="statusTV"
            :placeholder="$t('status')"
            box
            :selected="statusTV.find(s => s.value == status)"
            @selectedChange="e => onDropdownChange('status', e)"
          ></Dropdown>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        class="dt-button v1 s6"
        @click.stop="onAddProject"
      >
        {{$t('add_new_project')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";
import { createTV } from "../../../../models/text-value.model";
import { async } from "rxjs/internal/scheduler/async";
import { ProjectsService } from "../../services/projects.service";

export default {
  components: {
    Modal,
    TextField
  },

  props: ["statusList"],
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        isModel: true
      },

      project_name: "",
      status: "",

      statusItems: [
        { text: "planning", value: "planning" },
        { text: "current", value: "current" },
        { text: "back catalog", value: "back_catalog" }
      ]
    };
  },
  computed: {
    statusTV() {
      console.log("status nameeeeee ", this.statusList);
      console.log("status ", this.statusItems);
      return createTV(this.statusItems, "text", "value");
    }
  },
  methods: {
    onTextFieldValueChange: function(name, value) {
      this.newName = value;
      // console.log('new name', this.newName);
    },
    onDropdownChange(name, value) {
      console.log("name ", name, "value ", value);
      this[name] = value.value;
    },
    onAddProject: async function() {
      console.log("add Label modal");
      const res = await ProjectsService.addProject(
        this.project_name,
        this.status
      );
      console.log("new Project ", res.data);
      this.$emit("added", res.data);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    }
  }
};
</script>

<style></style>
